import styled from 'styled-components';

export const ProjectSectionStyled = styled.div`
  position: relative;
  width: 100%;

  .text-box {
    width: 100%;
    margin: 0 0 20px;
    color: var(--light-gray);

    .title {
      display: block;
      font-size: 22px;
      line-height: 26px;
      font-weight: 800;
      margin: 0 0 10px;
      color: var(--text-color);
    }
  }
`;
export const PageHeader = styled.div`
  gap: 60px;
  margin: 0 0 15px;
  font-size: 16px;
  line-height: 22px;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 5px;
  }

  @media (min-width: 1200px) {
    font-size: 18px;
  }

  .text-box {
    width: 100%;
    margin: 0 0 15px;

    @media (min-width: 768px) {
      margin: 0 0 20px;
    }
  }

  h1 {
    font-size: 25px;
    line-height: 30px;
    font-weight: 800;

    @media (min-width: 992px) {
      font-size: 32px;
      line-height: 36px;
    }
  }
`;

export const InfoProject = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
  padding: 25px;
  background: var(--white);
  border-radius: 20px;
  margin: 0 0 20px;

  .img-holder {
    flex-shrink: 0;
    width: 350px;

    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  .text-holder {
    flex-grow: 1;
    font-size: 18px;
    line-height: 22px;
    color: var(--light-gray);
  }
  .title {
    display: block;
    font-size: 22px;
    line-height: 26px;
    margin: 0 0 15px;
    color: var(--text-color);
  }
  p {
    margin: 0 0 20px;
  }
`;

export const ProjectCardHolder = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 10px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media (min-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (min-width: 1400px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
  }
`;
